// src/routesAdmin.js
import Icon from "@mui/material/Icon";

// Admin pages
import AdminDashboard from "layouts/admin/dashboard";
import AdminCustomers from "layouts/admin/customers";
import AdminScreens from "layouts/admin/screens";
import AdminMedia from "layouts/admin/media";
import AdminInvoices from "layouts/admin/invoices";
import AdminNotifications from "layouts/admin/notifications";
import ControlCenter from "layouts/control-center";
import MessengerPage from "layouts/messenger";
import Profile from "layouts/profile";

const routesAdmin = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "admin-dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/admin/dashboard",
    component: <AdminDashboard />,
  },
  {
    type: "collapse",
    name: "Control Center",
    key: "admin-control-center",
    icon: <Icon fontSize="small">settings_remote</Icon>,
    route: "/admin/control-center",
    component: <ControlCenter />,
  },
  {
    type: "collapse",
    name: "Kunden",
    key: "admin-customers",
    icon: <Icon fontSize="small">groups</Icon>,
    route: "/admin/kunden",
    component: <AdminCustomers />,
  },
  {
    type: "collapse",
    name: "Bildschirme",
    key: "admin-screens",
    icon: <Icon fontSize="small">tv</Icon>,
    route: "/admin/bildschirme",
    component: <AdminScreens />,
  },
  {
    type: "collapse",
    name: "Medien",
    key: "admin-media",
    icon: <Icon fontSize="small">perm_media</Icon>,
    route: "/admin/medien",
    component: <AdminMedia />,
  },
  {
    type: "collapse",
    name: "Rechnungen",
    key: "admin-invoices",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/admin/rechnungen",
    component: <AdminInvoices />,
  },
  {
    type: "collapse",
    name: "Benachrichtigungen",
    key: "admin-notifications",
    icon: <Icon fontSize="small">notifications</Icon>,
    route: "/admin/benachrichtigungen",
    component: <AdminNotifications />,
  },
  {
    type: "collapse",
    name: "Messenger",
    key: "admin-messenger",
    icon: <Icon fontSize="small">forum</Icon>,
    route: "/admin/messenger",
    component: <MessengerPage />,
  },
  {
    type: "hidden",
    name: "Profil",
    key: "admin-profile",
    route: "/admin/profile",
    component: <Profile />,
  },
  {
    type: "hidden",
    name: "Profil (Alias)",
    key: "admin-profile-alias",
    route: "/profile",
    component: <Profile />,
  },
];

export default routesAdmin;
